function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#22293E",
  d: "M4.998 4h24c.353 0 .692.14.942.39s.391.59.391.943v21.334c0 .353-.14.692-.39.942s-.59.391-.943.391h-24c-.354 0-.693-.14-.943-.39s-.39-.59-.39-.943V5.333c0-.353.14-.692.39-.942S4.644 4 4.998 4zM6.33 6.667v18.666h21.333V6.667H6.331zm6 12h7.333c.177 0 .347-.07.472-.196.125-.125.195-.294.195-.471s-.07-.346-.195-.471-.295-.196-.472-.196h-5.333c-.884 0-1.732-.35-2.357-.976-.625-.625-.976-1.473-.976-2.357 0-.884.35-1.732.976-2.357.625-.625 1.473-.976 2.357-.976h1.333V8h2.667v2.667h3.333v2.666h-7.333c-.177 0-.346.07-.471.196-.125.125-.196.294-.196.471s.07.346.196.471c.125.125.294.196.471.196h5.333c.884 0 1.732.35 2.357.976.625.625.977 1.473.977 2.357 0 .884-.352 1.732-.977 2.357-.625.625-1.473.976-2.357.976h-1.333V24h-2.667v-2.667h-3.333v-2.666z"
});

function SvgMoneySmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySmallIcon);
export default __webpack_public_path__ + "static/media/money_small_icon.6316b7c3.svg";
export { ForwardRef as ReactComponent };